module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLCz7Z11lFd2JQEl8qw.7def222d.woff2";